const $ = require('jquery')
const csrfTokenSupporter = require('../csrf_token_supporter')
const tips = require('../tips')

module.exports = (function () {
  $.extend({
    csrfAjax: function (reqData) {
      const defer = $.Deferred()

      if (!reqData.headers) {
        reqData.headers = {}
      }
      reqData.headers['X-CSRF-TOKEN'] = csrfTokenSupporter.getCsrfToken()

      const jqXHR = $.ajax(reqData)

      jqXHR.done(function (data, statusText, jqXHR) {
        // 必要になれば独自共通処理
        defer.resolveWith(this, arguments)
      })

      jqXHR.fail(function (jqXHR, statusText, errorThrown) {
        if (jqXHR.status === 500) {
          tips.headerTipsMessageLongRender('システムエラーが発生しました(500)', 'js-strong-tips hide error', 10000)
        }
        if (jqXHR.status === 404) {
          // 基本は起こらないはずなので主に開発中のデバック用
          tips.headerTipsMessageLongRender('リクエストに失敗しました(404)', 'js-strong-tips hide error', 10000)
        }
        if (jqXHR.status === 403) {
          tips.headerTipsMessageLongRender('許可されていません(403)', 'js-strong-tips hide error', 10000)
        }
        defer.rejectWith(this, arguments)
      })

      jqXHR.always(function (data) {
        // csrf tokenがパラメーターで返されてきていた場合は
        // metaタグを書き直す。
        if (data.Csrf) {
          csrfTokenSupporter.setCsrfToken(data.Csrf)
        }
        // errorの場合はresponseの取得方法が変わるので
        if (data.responseJSON && jqXHR.responseJSON.Csrf) {
          csrfTokenSupporter.setCsrfToken(jqXHR.responseJSON.Csrf)
        }
        defer.rejectWith(this, arguments)
      })

      return jqXHR
    }
  })
})()
